import content_tag_list from './tag-list';
import content_tag_add from './tag-add';
import content_tag_edit from './tag-edit';
import content_tag_detail from './tag-detail';

export default {
    content_tag_list,
    content_tag_add,
    content_tag_edit,
    content_tag_detail,
};
